import { Divider } from '@mui/material';
import * as React from 'react';
import { Col, Container, Row, Stack, Table } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ProjectSummary from '../Containers/ProjectSummary';

function ProjectModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="modal-90w"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
                <Divider>
                    <h4> { props.title } </h4>
                </Divider>
                </Modal.Title>
        </Modal.Header>
        <Modal.Body>         
        <Container>
            <Row>
                <Col xs={8} md={6}>
                    <p>{props.storyhook}</p>
                </Col>
                <Col xs={8} md={6}>
                    <Table striped bordered hover>
                        <tbody>
                            <tr>
                            <td><b>Team</b></td>
                            <td>{props.team}</td>

                            </tr>
                            <tr>
                            <td><b>Role(s):</b></td>
                            <td>{props.roles}</td>
                            </tr>
                            
                            <tr>
                            <td><b>Tools:</b></td>
                            <td>{props.tools}</td>
                            </tr>
                            <tr>
                            <td><b>Duration:</b></td>
                            <td>{props.duration}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>

            <Row>
                        {props.internalProjects.length > 0 && <h5>Highlights</h5>}
                <Stack gap={3}>
                    {props.internalProjects.map((item, index) => (
                        <div key={index} className="p-2 ">
                            <ProjectSummary
                                title={item.title}
                                summary={item.summary}
                                imageUrl={item.imageUrl}
                                altText={item.altText}
                                externalLink={item.externalLink}
                                linkText={item.linkText}
                            ></ProjectSummary>
                        </div>
                    ))}
                </Stack> 
            </Row>
        </Container>
                
        </Modal.Body>
        <Modal.Footer>
          <Button variant='outlined-primary' onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
  );
  
}

export default ProjectModal;